/**
 * Product Modules Accordion
 * Accordion de módulos para a grade curricular
 * 
 * Requirements: 7.5
 * - Criar toggle de expansão/colapso ao clicar no header
 * - Bloquear interação em módulos com ícone lock
 * 
 * @package MentoriaLeiSeca
 */

/**
 * Inicializa o accordion de módulos
 */
export function initProductModules() {
    const modulesList = document.querySelector('.sp-modules-list');
    
    if (!modulesList) {return;}
    
    const modules = modulesList.querySelectorAll('.sp-module');
    const headers = Array.from(modulesList.querySelectorAll('.sp-module-header'));
    
    if (modules.length === 0) {return;}
    
    modules.forEach(function(module) {
        const header = module.querySelector('.sp-module-header');
        const content = module.querySelector('.sp-module-content');
        const isLocked = module.classList.contains('locked') || module.querySelector('.sp-module-lock');
        
        if (!header) {return;}
        
        // Requirement 7.5: Bloquear interação em módulos com ícone lock
        if (isLocked) {
            header.setAttribute('aria-disabled', 'true');
            header.style.cursor = 'not-allowed';
            return;
        }

        header.setAttribute('aria-expanded', module.classList.contains('open') ? 'true' : 'false');
        
        // Requirement 7.5: Toggle de expansão/colapso ao clicar no header
        header.addEventListener('click', function(e) {
            e.preventDefault();
            toggleModule(module);
        });
        
        // Suporte a teclado (Enter e Space)
        header.addEventListener('keydown', function(e) {
            const currentIndex = headers.indexOf(header);

            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleModule(module);
                return;
            }

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const nextIndex = (currentIndex + 1) % headers.length;
                headers[nextIndex].focus();
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                const prevIndex = (currentIndex - 1 + headers.length) % headers.length;
                headers[prevIndex].focus();
            }

            if (e.key === 'Home') {
                e.preventDefault();
                headers[0].focus();
            }

            if (e.key === 'End') {
                e.preventDefault();
                headers[headers.length - 1].focus();
            }
        });
    });
}

/**
 * Toggle de um módulo específico
 * @param {HTMLElement} module - Elemento do módulo
 */
function toggleModule(module) {
    if (!module) {return;}
    
    const isLocked = module.classList.contains('locked') || module.querySelector('.sp-module-lock');
    
    // Não fazer nada se o módulo está bloqueado
    if (isLocked) {return;}
    
    const isOpen = module.classList.contains('open');
    const content = module.querySelector('.sp-module-content');
    const header = module.querySelector('.sp-module-header');
    
    if (isOpen) {
        // Fechar módulo
        module.classList.remove('open');
        if (content) {
            content.setAttribute('hidden', '');
        }
        if (header) {
            header.setAttribute('aria-expanded', 'false');
        }
    } else {
        // Abrir módulo
        module.classList.add('open');
        if (content) {
            content.removeAttribute('hidden');
        }
        if (header) {
            header.setAttribute('aria-expanded', 'true');
        }
    }
}

/**
 * Toggle de módulo por índice (para uso global/inline)
 * @param {number} idx - Índice do módulo
 */
export function toggleModuleByIndex(idx) {
    const module = document.querySelector(`[data-module="${idx}"]`);
    
    if (!module) {return;}
    
    toggleModule(module);
}

/**
 * Handler para eventos de teclado no módulo
 * @param {KeyboardEvent} event - Evento de teclado
 * @param {number} idx - Índice do módulo
 */
export function handleModuleKeydown(event, idx) {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleModuleByIndex(idx);
    }
}

// Expor funções globalmente para uso inline no PHP
if (typeof window !== 'undefined') {
    window.toggleModule = toggleModuleByIndex;
    window.handleModuleKeydown = handleModuleKeydown;
}

export default initProductModules;
